import { ScreenSkeleton } from '@multaqa/ui/components/async/screen-skeleton'
import { useRouterState } from '@tanstack/react-router'
import { useSyncExternalStore } from 'react'
import { ShellFrameSkeleton } from '@/components/shell-frame-skeleton'
import { isBootSplashPresent, subscribeToBootSplashRemoval } from '@/lib/boot-splash'

export function RoutePending() {
  const bootSplashPresent = useSyncExternalStore(
    subscribeToBootSplashRemoval,
    isBootSplashPresent,
    () => false,
  )
  const authenticated = useRouterState({
    select: (state) => state.matches.some((match) => match.routeId === '/_authenticated'),
  })
  // The layout itself is loading, so the shell is not mounted and has no rail yet.
  const layoutPending = useRouterState({
    select: (state) =>
      state.matches.some(
        (match) => match.routeId === '/_authenticated' && match.status === 'pending',
      ),
  })

  // Even under the splash: the frame's rail logo is the target the boot M flies to
  if (layoutPending) return <ShellFrameSkeleton />
  // Hidden: the splash hands a public route off once this marker is gone
  if (bootSplashPresent) return <div data-boot-pending hidden />
  if (!authenticated) return <div className="min-h-svh bg-background" />

  return <ScreenSkeleton className="min-h-svh bg-background" />
}
